export const API_STATUS = {
  NEW: 'new',
  DEPRECATED: 'deprecated',
} as const;

export type ApiStatusType = (typeof API_STATUS)[keyof typeof API_STATUS];
export type ApiStatusDisplayType = ApiStatusType | null;

export interface ProductDoc {
  path: string;
  url: string;
  downloadUrl: string;
  title: string;
  id: string;
}

export interface ProductData {
  id: string;
  title: string;
  description: string;
  tag: string;
  type: string;
  system?: string;
  docs: ProductDoc[];
  thumbnails: Array<{ path: string; url: string; downloadUrl: string }>;
  isAccessGranted: boolean | null;
  specs: Array<{
    path: string;
    version: string;
    url: string;
    downloadUrl: string;
  }>;
  new: boolean;
  deprecated: boolean;
  clientCredentials: string[];
}

export interface ProductsPageFilter {
  types: string[];
  search?: string;
  tags?: string[];
  isAccessGranted?: boolean;
}

export interface ProductsPageRequest {
  page: number;
  limit: number;
  filter: ProductsPageFilter;
}

export interface ProductsPageResponse {
  elements: ProductData[];
  isFirst: boolean;
  isLast: boolean;
  page: number;
  total: number;
  totalPages: number;
}

export const API_PRODUCT_TYPE = 'api';
export const API_PAGE_SIZE = 7;
export const API_EXPLORER_PATH = '/api-docs';

export interface ApiExplorerLocationState {
  fromSearch?: string;
}

export interface ResourceTagCount {
  tag: string;
  count: number;
}

export interface ResourceTagsResponse {
  elements: ResourceTagCount[];
}
